import script from "./forgotPasswordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./forgotPasswordModal.vue?vue&type=script&setup=true&lang=ts"

import "./forgotPasswordModal.vue?vue&type=style&index=0&id=0acd29a4&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0acd29a4"]])

export default __exports__